export default class MercadopagoCardController {
  constructor(element) {
    this.element = element
    this.publicKey = element.dataset.mercadopagoCardPublicKeyValue
    this.brickController = null

    this.initBrick()
  }

  async initBrick() {
    if (!window.MercadoPago) {
      console.error("MercadoPago SDK not loaded")
      return
    }

    this.mp = new window.MercadoPago(this.publicKey, { locale: "es-UY" })
    const bricksBuilder = this.mp.bricks()

    try {
      this.brickController = await bricksBuilder.create("cardPayment", this.element.id, {
        initialization: { amount: 1 },
        customization: {
          visual: {
            style: { theme: "default" },
            hideFormTitle: true
          },
          paymentMethods: { maxInstallments: 1 }
        },
        callbacks: {
          onReady: () => {},
          onSubmit: async (cardFormData) => {
            await this.handleSubmit(cardFormData)
          },
          onError: (error) => {
            console.error("MercadoPago Brick error:", error)
          }
        }
      })
    } catch (error) {
      console.error("Error creating CardPayment Brick:", error)
    }
  }

  async handleSubmit(cardFormData) {
    if (!cardFormData || !cardFormData.token) {
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch('/card_verification', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          card_token: cardFormData.token,
          national_id: document.getElementById('national_id')?.value || '',
          phone_number: document.getElementById('phone_number')?.value || ''
        })
      })

      if (response.ok || response.redirected) {
        window.location.reload()
      } else {
        const data = await response.json()
        console.error("Card registration failed:", data.error)
      }
    } catch (err) {
      console.error("Card registration error:", err)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="mercadopago-card"]').forEach(el => {
    new MercadopagoCardController(el)
  })
})
